import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty } from '../Service/Utils';
import AuthFetchService from '../Service/AuthFetchService';

import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { Base64 } from 'js-base64';
import React from 'react';
import { Radio, Button, Input, Breadcrumb, DatePicker, Select, Form, Card, TreeSelect, Space, Row, Col, Modal, message, Upload} from 'antd';
import { PlusOutlined, MinusOutlined, SwapOutlined, FolderAddOutlined,UploadOutlined } from '@ant-design/icons';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
const WX_OPEN_ID_OPTIONS = [
    {
        label: '薄荷',
        value: 'mint'
    }, {
        label: '芝士派',
        value: 'cya'
    }, {
        label: '蛋糕训练营',
        value: 'cake_pap'
    }, {
        label: '蛋糕年课',
        value: 'cake_ralph'
    }, {
        label: '蛋糕App',
        value: 'cake_hodor'
    }, {
        label: '夜曲',
        value: 'nocturne'
    }, {
        label: '柚子鸭',
        value: 'kids'
    }
];

const { RangePicker } = DatePicker;

class UserClusteringEditor extends React.Component {
    constructor() {
        super();
        this.state = {
            clustering: {
                name: '',
                scheduleType: 'ONE_SHOT',
                appKeyId: null,
                condition: {
                    logic: 'AND',
                    //tagId: '',
                    category: 'DIR',
                    operator: 'EQUAL',
                    rhs: [{
                        logic: 'AND',
                        category: '',
                        tagId: '',
                        operator: 'EQUAL',
                        rhs: []
                    }]
                },
                beginDate: moment().format('yyyy-MM-DD'),
                endDate: moment().add(1, 'month').format('yyyy-MM-DD'),
                ownerId: -1
            },
            tags: [],
            provinces: [],
            bookCategories: [],
            apis: []
        };
    }

    async componentDidMount() {
        UIFetchService
            .get('/api/v1/metadata/tags/tree?filter=clustering')
            .then(tags => { this.setState({ tags: tags }) });
        UIFetchService
            .get('/api/v1/metadata/provinces/tree')
            .then(provinces => { this.setState({ provinces: provinces }) });
        UIFetchService
            .get('/api/v1/metadata/word_books/tree')
            .then(categories => { this.setState({ bookCategories: categories }) });
        UIFetchService
            .get('/api/v1/metadata/api/summaries')
            .then(apis => { this.setState({ apis: [{ appKeyId: null, notes: '不提供' }, ...apis] }) });

        let domNode = document.getElementById('site-code-mode-sql');
        let instance = monaco.editor.create(domNode, {
            value: '',
            theme: 'vs-light',
            fontSize: 11,
            language: 'sql',
            automaticLayout: true
        });
        this.codeEditor = instance;

        if (!this.props.createOrEdit && this.props.clusteringId !== undefined) {
            const clustering = await UIFetchService.get(`/api/v1/user_clustering/definitions/${this.props.clusteringId}`);
            this.setState({ clustering: clustering });

            if (clustering.condition.logic === 'CODE') {
                this.codeEditor.setValue(clustering.condition.rhs[0]);
            }
        }
    }

    componentWillUnmount() {
        this.codeEditor?.dispose();
    }

    render() {
        return <>
            <Row>
                <Breadcrumb>
                    <Breadcrumb.Item>用户分群</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Button type="link" size="small" onClick={() => this.props.onBackward()}>分群列表</Button>
                    </Breadcrumb.Item>
                    {this.props.createOrEdit ? <Breadcrumb.Item>分群新建</Breadcrumb.Item>:<Breadcrumb.Item>分群编辑</Breadcrumb.Item>}
                </Breadcrumb>
            </Row>
            <div style={{ height: '20px' }} />
            <Row>
             <Col offset = {1} span={12}>
                <Form labelCol={{ span: 4 }} wrapperCol={{span: 8}}> 
                        <Form.Item label="人群名称">
                            <Input 
                                value={this.state.clustering.name}
                                onChange={(e) => {
                                    const state = this.state.clustering;
                                    state.name = e.target.value;
                                    this.setState({ clustering: state });
                                }}
                            />
                        </Form.Item>
                        <Form.Item label="分群配置模式">
                            <Select defaultValue="向导模式"
                                value={this.state.clustering.condition.logic}
                                onChange={(value) => {
                                        let state = this.state.clustering;
                                        state.condition.logic = value;
                                        this.setState({ clustering: state });
                                    }}
                                options={[
                                    {value: "AND",label: "向导模式"},
                                    {value: "CODE",label: "代码模式"}
                                    // {value: "UPLOAD",label: "上传人群包"},
                                ]}
                            />
                        </Form.Item>
                        <Form.Item label="计算方式" extra="提示：单次计算只在提交时计算一次，数据有效期为14天(过期无法调用API)">
                            <Radio.Group
                                defaultValue="DAILY"
                                value={this.state.clustering.scheduleType}
                                onChange={(value) => {
                                    //console.log(value);
                                    const state = this.state.clustering;
                                    state.scheduleType = value.target.value;
                                    this.setState({ clustering: state });
                                }}>
                                <Radio value="ONE_SHOT">单次计算</Radio>
                                {this.state.clustering.condition.logic!='UPLOAD' && <Radio value="DAILY">每日更新</Radio>}
                            </Radio.Group>
                        </Form.Item>
                        {this.state.clustering.scheduleType === 'DAILY' && 
                        <Form.Item label="生效周期">
                            <RangePicker defaultValue={[moment(this.state.clustering.beginDate), moment(this.state.clustering.endDate)]} onChange={(dateRange) => {
                                let state = this.state.clustering;
                                state.beginDate = dateRange[0].format('yyyy-MM-DD');
                                state.endDate = dateRange[1].format('yyyy-MM-DD');
                                this.setState({clustering: state})
                            }}/>
                        </Form.Item>}
                            <Form.Item label="API提供">
                                <Select
                                    value={this.state.clustering.appKeyId}
                                    onChange={(value) => {
                                        //console.log(value);
                                        const state = this.state.clustering;
                                        state.appKeyId = value;
                                        delete state.identifier;
                                        this.setState({ clustering: state });
                                    }}>
                                    {this.state.apis.map((api, index) =>
                                        <Select.Option key={index} value={api.appKeyId}>{api.appKeyId === null ? api.notes : `${api.notes} [${api.appKeyId}]`}</Select.Option>)}
                                </Select>
                            </Form.Item>
                            {this.state.clustering.appKeyId === 'oid_push' && <Form.Item label="输出ID">
                                <Select
                                    value={this.state.clustering.identifier}
                                    defaultValue="bcz_uid"
                                    onChange={value => this.setState(({ clustering }) => {
                                        clustering.identifier = value;
                                        return { clustering };
                                    })}>
                                    <Select.Option key="bcz_uid" value="bcz_uid">bcz_uid</Select.Option>
                                    <Select.Option key="unionid" value="unionid">UnionId</Select.Option>
                                    {WX_OPEN_ID_OPTIONS.map(id =>
                                        <Select.Option key={`openid:${id.value}`} value={`openid:${id.value}`}>{`OpenId: ${id.label}`}</Select.Option>)}
                                </Select>
                            </Form.Item>}
                    </Form>
                </Col>
            </Row>

            {this.isNormalMode() && <Row>
                <span>分群配置（向导模式）</span>
            </Row>}
            {this.isCodeMode() && <Row>
                <span>分群配置（代码模式）</span>
            </Row>}
            {this.isUploadMode() && <Row>
                <span>分群配置（上传人群包）</span>
            </Row>}
            <div style={{ height: 10 }} ></div>

            {this.isNormalMode() &&
                this.renderConditionItem(this.state.clustering.condition, undefined, undefined, 0)}
            
            <Card hidden={!this.isCodeMode()}>
                <Row>
                    <p style={{ margin: '0px' }}>使用SQL代码定义人群。</p>
                </Row>
                <Row>
                    <p style={{ margin: '0px' }}>注意：代码必须是一条SELECT语句，并且只输出一个字段: 
                        <span style={{ color: 'red' }}>{`${this.getIdentifierNameAndType()[0]}: ${this.getIdentifierNameAndType()[1]}`}</span>
                    </p>
                </Row>
                <div style={{ height: 10 }}></div>
                <Row>
                    <Col flex="100%">
                        <div id="site-code-mode-sql" style={{ textAlign: 'left', height: 400, border: '1px' }}>

                        </div>
                    </Col>
                </Row>
            </Card>

            {this.isUploadMode() && 
            <Card>
                <Row>
                    <p style={{ margin: '0px' }}>注意：仅支持上传txt或excel文件，文件大小10MB以内；</p>
                </Row>
                <Row>
                    <p style={{ margin: '0px' }}>上传的文件内，应仅包含一列<span style={{ color: 'red' }}>bcz_uid</span>值，无需添加字段名和分隔符</p>
                </Row>
                <div style={{ height: 10 }} ></div>
                <Row style={{height: 400}}>
                <Upload 
                    name="file"
                    action={`/api/v1/sampling/pictures/temp_media_file`}
                    accept="csv;xls/xlsx;txt"
                    maxCount={1}
                    showUploadList={false}
                    onChange={info => this.uploadingDidChanged(info)}
                    beforeUpload={file => {
                        return true;
                    }}>
                    <Button
                        icon={<UploadOutlined />}
                        style={{ color: '#1890ff' }}
                    >选择本地文件</Button>
                </Upload>
                </Row>
            </Card>}

            <div style={{ height: '20px' }} />
            <Row>
                <Col flex="30%" />
                <Col flex="30%">
                    {this.allowDefinitionEdit() && 
                    <Space>
                        <Button type="primary" onClick={this.clusteringDefinitionDidSaved}>保存</Button>
                        <Button onClick={this.props.onBackward}>取消</Button>
                    </Space>}
                    {!this.allowDefinitionEdit() && 
                    <Space>
                        <Button onClick={this.props.onBackward}>返回</Button>
                    </Space>}
                </Col>
                <Col flex="30%" />
            </Row>
        </>
    }

    allowDefinitionEdit() {
        return AuthFetchService.uid === this.state.clustering.ownerId || AuthFetchService.allow('datap:admin') || this.state.clustering.ownerId === -1
    }

    getIdentifierNameAndType() {
        if (isEmpty(this.state.clustering.identifier) || this.state.clustering.identifier === 'bcz_uid') {
            return ['bcz_uid', 'BIGINT'];
        }
        if (this.state.clustering.identifier === 'unionid') {
            return ['union_id', 'STRING'];
        }
        return ['open_id', 'STRING'];
    }

    switchCodeMode() {
        const initialSql = `SELECT ${this.getIdentifierNameAndType()[0]} FROM ads_group_user_profile`;
        const onOk = () => this.setState(({ clustering }) => {
            clustering.condition = {
                logic: 'CODE',
                category: 'SQL',
                tagId: '0',
                operator: 'EXEC',
                rhs: [initialSql]
            };
            return { clustering };
        });

        if (!this.checkClusteringCondition(this.state.clustering.condition)) {
            this.setState(({ clustering }) => {
                return { clustering };
            });

            this.codeEditor.setValue(initialSql);
            Modal.confirm({
                title: '模式转换',
                content: <>
                    <span>当前规则配置有误，无法迁移到代码模式，是否丢弃当前规则并继续？</span>
                </>,
                cancelText: '放弃',
                okText: '转换',
                onOk
            });
        } else {
            UIFetchService.post(`/api/v1/user_clustering/definitions/${this.props.clusteringId}/condition/sql`,
                this.state.clustering.condition)
                .then(json => {
                    if (!json || !json.sql) {
                        return;
                    }
                    this.codeEditor.setValue(json.sql);
                    this.setState(({ clustering }) => {
                        clustering.condition = {
                            logic: 'CODE',
                            category: 'SQL',
                            tagId: '0',
                            operator: 'EXEC',
                            rhs: [json.sql]
                        };
                        return { clustering };
                    })
                })
        }
    }

    switchNormalMode() {
        const onOk = () => this.setState(({ clustering }) => {
            clustering.logic = 'AND';
            clustering.condition = {
                logic: 'AND',
                //tagId: '',
                category: 'DIR',
                operator: 'EQUAL',
                rhs: [{
                    logic: 'AND',
                    category: '',
                    tagId: '',
                    operator: 'EQUAL',
                    rhs: []
                }]
            };
            return { clustering };
        });
        Modal.confirm({
            title: '模式转换',
            content: <>
                <span>转换到向导模式；会丢失当前配置，是否继续？</span>
            </>,
            cancelText: '放弃',
            okText: '转换',
            onOk
        });
    }

    isCodeMode() {
        return this.state.clustering.condition.logic === 'CODE';
    }

    isNormalMode() {
        return this.state.clustering.condition.logic === 'AND';
    }

    isUploadMode() {
        return this.state.clustering.condition.logic === 'UPLOAD';
    }

    renderConditionItem(item, parent, index, offset) {
        if (item.category === 'DIR') {
            const showHeader = (isNotEmpty(item.logic) && item?.rhs?.length > 1) || parent !== undefined;
            return <>
                <Card>
                    {showHeader && <>
                        <Row>
                            <Col>
                                <Space>
                                    {(isNotEmpty(item.logic) && item?.rhs?.length > 1) && <Radio.Group
                                        defaultValue="AND"
                                        optionType="button"
                                        buttonStyle="solid"
                                        value={item.logic}
                                        size="small"
                                        onChange={(e) => {
                                            const state = this.state.clustering;
                                            item.logic = e.target.value;
                                            this.setState({ clustering: state });

                                        }}
                                    >
                                        <Radio.Button value="AND">AND</Radio.Button>
                                        <Radio.Button value="OR">OR</Radio.Button>
                                    </Radio.Group>}
                                    {parent !== undefined && <Button
                                        type="default"
                                        icon={<MinusOutlined />}
                                        size="small"
                                        onClick={() => this.clusteringConditionDidRemoved(parent, index)} />}
                                </Space>
                            </Col>
                        </Row>
                        <div style={{ height: 10 }}></div>
                    </>}
                    {item.rhs.map((node, i) => this.renderConditionItem(node, item, i, offset))}
                    <Row>
                        <Col>
                            <Space>
                                <Button
                                    type="default"
                                    icon={<FolderAddOutlined />}
                                    size="small"
                                    onClick={() => this.clusteringConditionDidAdded(item, 'dir')} />
                                <Button
                                    type="default"
                                    icon={<PlusOutlined />}
                                    size="small"
                                    onClick={() => this.clusteringConditionDidAdded(item, 'node')} />
                            </Space>
                        </Col>
                    </Row>
                    {isNotEmpty(item.error) && <>
                        <div style={{ height: 10 }}></div>
                        <Row>
                            <Col>
                                <span style={{ color: 'red' }}>{item.error}</span>
                            </Col>
                        </Row>
                    </>}
                </Card>
                <div style={{ height: '10px' }} />
            </>
        }

        let tags = this.state.tags
            .find((category) => category.key === item.category)?.children;
        tags = tags === undefined ? [] : tags;
        const tag = tags?.find((tag) => tag.key === item.tagId?.toString());
        return <>
            <Row>
                <Col flex="200px">
                    <Select
                        style={{ width: '90%' }}
                        value={item.category}
                        size="small"
                        onChange={(value) => this.clusteringConditionCategoryDidChanged(item, value)}
                    >
                        {this.state.tags.map(category =>
                            <Select.Option value={category.key}>{category.title}</Select.Option>
                        )}
                    </Select>
                </Col>
                <Col flex="300px">
                    <Select
                        style={{ width: '90%' }}
                        value={item.tagId?.toString()}
                        size="small"
                        onChange={(value) => this.clusteringConditionTagDidChanged(item, value)}
                    >
                        {tags.map(tag => <Select.Option value={tag.key.toString()}>{tag.title}</Select.Option>)}
                    </Select>
                </Col>
                <Col flex="100px">
                    <Select
                        style={{ width: '90%' }}
                        defaultValue={"EQUAL"}
                        value={item.operator}
                        size="small"
                        onChange={(value) => this.clusteringConditionOperatorDidChanged(item, value)}
                    >
                        <Select.Option value="EQUAL">等于</Select.Option>
                        <Select.Option value="NOT_EQUAL">不等于</Select.Option>
                        <Select.Option value="IS_NULL">未知</Select.Option>
                        <Select.Option value="IS_NOT_NULL">有值</Select.Option>
                    </Select>
                </Col>
                <Col flex="300px">

                    {(item.operator === 'EQUAL' || item.operator === 'NOT_EQUAL') &&
                        this.renderConditionRhs(tag === undefined ? '' : tag.value, item)}
                </Col>
                <Space>
                    <Col>
                        <Button
                            type="default"
                            icon={<SwapOutlined />}
                            shape="circle"
                            size="small"
                            onClick={() => this.clusteringConditionDidSwitched(parent, index)}
                        />
                    </Col>
                    <Col>
                        <Button
                            type="default"
                            icon={<MinusOutlined />}
                            shape="circle"
                            size="small"
                            onClick={() => this.clusteringConditionDidRemoved(parent, index)}
                        />
                    </Col>
                </Space>
            </Row>
            {isNotEmpty(item.error) && <>
                <div style={{ height: 10 }}></div>
                <Row>
                    <Col>
                        <span style={{ color: 'red' }}>{item.error}</span>
                    </Col>
                </Row>
            </>}
            <div style={{ height: '10px' }} />
        </>
    }

    renderConditionRhs(type, item) {
        const state = this.state.clustering;
        const condition = item;
        switch (type) {
            case 'BETWEEN_TO':
                return <Space style={{ width: '90%' }}>
                    <Input
                        value={condition.rhs[0]}
                        size="small"
                        onChange={(e) => {
                            if (!condition.rhs || condition.rhs.length < 2) {
                                condition.rhs = [null, null];
                            }
                            condition.rhs[0] = e.target.value;
                            this.setState({ clustering: state });
                        }}
                    />
                    <span>到</span>
                    <Input
                        value={condition.rhs[1]}
                        size="small"
                        onChange={(e) => {
                            if (!condition.rhs || condition.rhs.length < 2) {
                                condition.rhs = [null, null];
                            }
                            condition.rhs[1] = e.target.value;
                            this.setState({ clustering: state });
                        }} />
                </Space>

            case 'WORD_BOOK':
                return <TreeSelect
                    showSearch
                    style={{ width: '90%' }}
                    value={condition.rhs}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择单词本"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    filterTreeNode={(value, node) => {
                        if (!node.title) {
                            return false;
                        }
                        return node.title.indexOf(value) >= 0;
                    }}
                    onChange={(value) => {
                        //console.log(value);
                        const books = new Set([]);
                        for (let key of value) {
                            const node = this.state.bookCategories.find(category => category.key === key);
                            if (node !== undefined) {
                                for (let book of node.children) {
                                    books.add(book.title);
                                }
                            } else {
                                books.add(key);
                            }
                        }
                        condition.rhs = [];
                        for (let book of books) {
                            condition.rhs.push(book);
                        }
                        this.setState({ clustering: state });
                    }}
                >
                    {this.state.bookCategories.map((category) =>
                        <TreeSelect.TreeNode value={category.key} key={category.key} title={category.title}>
                            {category.children.map(book =>
                                <TreeSelect.TreeNode value={book.title} key={book.key} title={`(${book.key})${book.title}`} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>;

            case 'WORD_BOOK_ID':
                return <TreeSelect
                    showSearch
                    style={{ width: '90%' }}
                    value={condition.rhs}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择单词本"
                    allowClear
                    multiple
                    filterTreeNode={(value, node) => {
                        if (!node.title) {
                            return false;
                        }
                        return node.title.indexOf(value) >= 0;
                    }}
                    treeDefaultExpandAll
                    onChange={(value) => {
                        //console.log(value);
                        const books = new Set([]);
                        for (let key of value) {
                            const node = this.state.bookCategories.find(category => category.key === key);
                            if (node !== undefined) {
                                for (let book of node.children) {
                                    books.add(book.title);
                                }
                            } else {
                                books.add(key);
                            }
                        }
                        condition.rhs = [];
                        for (let book of books) {
                            condition.rhs.push(book);
                        }
                        this.setState({ clustering: state });
                    }}
                >
                    {this.state.bookCategories.map((category) =>
                        <TreeSelect.TreeNode value={category.key} key={category.key} title={category.title}>
                            {category.children.map(book =>
                                <TreeSelect.TreeNode value={book.key} key={book.key} title={`(${book.key})${book.title}`} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>

            case 'DATE_RANGE':
                return <DatePicker.RangePicker
                    style={{ width: '90%' }}
                    locale={locale}
                    value={[moment(condition.rhs[0]), moment(condition.rhs[1])]}
                    size="small"
                    onChange={(date) => {
                        condition.rhs = [
                            date[0]?.format('YYYY-MM-DD'),
                            date[1]?.format('YYYY-MM-DD')
                        ];
                        this.setState({ clustering: state });
                    }}
                />

            case 'YES_OR_NO':
                return <Select
                    style={{ width: '90%' }}
                    placeholder="是/否"
                    value={condition.rhs[0]}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = [value];
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option value="是">是</Select.Option>
                    <Select.Option value="否">否</Select.Option>
                </Select>

            case 'ONE_OR_ZERO':
                return <Select
                    style={{ width: '90%' }}
                    placeholder="是/否"
                    value={condition.rhs[0]}
                    onChange={(value) => {
                        condition.rhs = [value];
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option value="1">是</Select.Option>
                    <Select.Option value="0">否</Select.Option>
                </Select>

            case 'SEX':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择性别"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option key="男">男</Select.Option>
                    <Select.Option key="女">女</Select.Option>
                </Select>

            case 'PROVINCE':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择省份"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    {this.state.provinces.map(province => <Select.Option key={province.title}>{province.title}</Select.Option>)}
                </Select>

            case 'CITY':
                return <TreeSelect
                    showSearch
                    style={{ width: '90%' }}
                    value={condition.rhs}
                    size="small"
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    placeholder="选择城市"
                    allowClear
                    multiple
                    treeDefaultExpandAll
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    {this.state.provinces.map((province) =>
                        <TreeSelect.TreeNode value={province.key} title={province.title}>
                            {province.children.map(city =>
                                <TreeSelect.TreeNode value={city.title} title={city.title} />)}
                        </TreeSelect.TreeNode>)}
                </TreeSelect>

            case 'CITY_LEVEL':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择城市等级"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option key="一线城市">一线城市</Select.Option>
                    <Select.Option key="新一线城市">新一线城市</Select.Option>
                    <Select.Option key="二线城市">二线城市</Select.Option>
                    <Select.Option key="三线城市">三线城市</Select.Option>
                    <Select.Option key="四线城市">四线城市</Select.Option>
                    <Select.Option key="五线城市">五线城市</Select.Option>
                </Select>

            case 'IDENTITY':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择身份"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option key="小学生">小学生</Select.Option>
                    <Select.Option key="初中生">初中生</Select.Option>
                    <Select.Option key="高中生">高中生</Select.Option>
                    <Select.Option key="大学生">大学生</Select.Option>
                    <Select.Option key="工作党">工作党</Select.Option>
                    <Select.Option key="其他">其他</Select.Option>
                </Select>

            case 'DEVICE_KIND':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择设备类型"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option key="iphone">Apple iPhone</Select.Option>
                    <Select.Option key="ipad">Apple iPad</Select.Option>
                    <Select.Option key="android">安卓设备</Select.Option>
                </Select>

            case 'EDUCATION':
                return <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '90%' }}
                    placeholder="选择学历"
                    value={condition.rhs}
                    size="small"
                    onChange={(value) => {
                        condition.rhs = value;
                        this.setState({ clustering: state });
                    }}
                >
                    <Select.Option key="小学">小学</Select.Option>
                    <Select.Option key="初中">初中</Select.Option>
                    <Select.Option key="高中">高中</Select.Option>
                    <Select.Option key="职高">职高</Select.Option>
                    <Select.Option key="大学">大学</Select.Option>
                </Select>

            case 'DEFAULT':
            default:
                if (type.startsWith('OPTS:')) {
                    const options = type.substring(5).split(',');
                    return <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '90%' }}
                        placeholder={options.join('/')}
                        value={condition.rhs}
                        size="small"
                        onChange={(value) => {
                            condition.rhs = value;
                            this.setState({ clustering: state });
                        }}
                    >
                        {options.map(key => <Select.Option key={key}>{key}</Select.Option>)}
                    </Select>
                }
                return <Space style={{ width: '90%' }}>
                    <Input
                        value={condition.rhs[0]}
                        size="small"
                        onChange={(e) => {
                            condition.rhs = [e.target.value];
                            this.setState({ clustering: state });
                        }}
                    />
                </Space>
        }
    }

    clusteringConditionDidAdded(item, type) {
        const state = this.state.clustering;
        if (type === 'node') {
            item.rhs.push({
                logic: 'AND',
                category: '',
                //tagId: '',
                operator: 'EQUAL',
                rhs: []
            });
        } else if (type === 'dir') {
            item.rhs.push({
                logic: 'AND',
                category: 'DIR',
                //tagId: '',
                operator: '',
                rhs: []
            });
        }
        this.setState({ clustering: state });
    }

    clusteringConditionDidRemoved(item, index) {
        const state = this.state.clustering;
        if (item.rhs.length === 0) {
            return;
        }
        const newConditions = [];
        item.rhs.forEach((value, i) => {
            if (i !== index) {
                newConditions.push(value)
            }
        });
        item.rhs = newConditions;
        this.setState({ clustering: state });
    }

    clusteringConditionDidSwitched(item, index) {
        const state = this.state.clustering;
        if (item.rhs.length === 0) {
            return;
        }
        const condition = item.rhs[index];
        item.rhs[index] = {
            logic: 'AND',
            category: 'DIR',
            rhs: [condition]
        };
        this.setState({ clustering: state });
    }

    clusteringConditionCategoryDidChanged(item, value) {
        const state = this.state.clustering;
        item.category = value;
        item.tagId = null;
        item.rhs = [];
        this.setState({ clustering: state });
    }

    clusteringConditionTagDidChanged(item, value) {
        const state = this.state.clustering;
        item.tagId = value;
        item.rhs = [];
        this.setState({ clustering: state });
    }

    clusteringConditionOperatorDidChanged(item, value) {
        const state = this.state.clustering;
        item.operator = value;
        item.rhs = [];
        this.setState({ clustering: state });
    }

    clusteringDefinitionDidSaved = async () => {
        if (this.isCodeMode()) {
            this.state.clustering.condition = {
                logic: 'CODE',
                category: 'SQL',
                tagId: '0',
                operator: 'EXEC',
                rhs: [Base64.encode(this.codeEditor.getValue().endsWith(';')? this.codeEditor.getValue().replace(';',''):this.codeEditor.getValue())]
            };
        } else if(this.isNormalMode()) {
            if (!this.checkClusteringCondition(this.state.clustering.condition)) {
                this.setState(({ clustering }) => {
                    return { clustering };
                });
                return;
            }
        } else {
            //上传人群包
        }

        if (this.props.createOrEdit) {
            const result = await UIFetchService.post('/api/v1/user_clustering/definition',
                this.state.clustering);
            if (result !== undefined) {
                message.success('新建分群成功！')
                this.props.onBackward();
            }
        } else {
            const result = await UIFetchService.put(`/api/v1/user_clustering/definitions/${this.props.clusteringId}`,
                this.state.clustering);
            if (result !== undefined) {
                message.success('保存分群成功！')
                this.props.onBackward();
            }
        }
    }

    checkClusteringCondition(condition) {
        if (isEmpty(condition.logic)) {
            condition.error = '没有指定逻辑运算符';
            return false;
        }

        if (isEmpty(condition.category)) {
            condition.error = '没有指定字段';
            return false;
        }

        if (condition.category === 'DIR') {
            if (condition.rhs === null ||
                condition.rhs === undefined ||
                condition.rhs.length == 0) {
                condition.error = '子表达式不能为空';
                return false;
            }

            let failCount = 0
            for (let child of condition.rhs) {
                if (!this.checkClusteringCondition(child)) {
                    failCount++;
                }
            }
            if (failCount > 0) {
                return false;
            }
        } else {
            if (isEmpty(condition.operator)) {
                condition.error = '没有指定字段';
                return false;
            }

            if (condition.operator === 'EQUAL' || condition.operator === 'NOT_EQUAL') {
                if (condition.rhs === null || condition.rhs === undefined ||
                    condition.rhs.length < 1) {
                    condition.error = '参数不能为空';
                    return false;
                }
            }
        }

        return true;
    }
} // class UserClusteringEditor


export default UserClusteringEditor;
